import { render, staticRenderFns } from "./UserVaultSummary.vue?vue&type=template&id=0080bed6&"
import script from "./UserVaultSummary.vue?vue&type=script&lang=js&"
export * from "./UserVaultSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports